import { useMemo, useState } from "react";
import Sidebar from "../../Components/Sidebar/Sidebar";
import Header from "../../Components/Header/Header";
import classes from "./Billings.module.css";
import CreateInvoiceModal from "./CreateInvoiceModal";
import {
    FaFileInvoiceDollar,
    FaMoneyBillWave,
    FaWallet,
    FaCoins,
    FaUndo,
    FaArrowUp,
    FaArrowDown,
    FaPlus,
    FaSearch,
    FaFilter,
    FaEye,
    FaPrint,
    FaChevronLeft,
    FaChevronRight,
    FaCreditCard,
    FaUniversity,
    FaShieldAlt,
    FaClock,
    FaCheckCircle,
    FaTimesCircle,
    FaHourglassHalf,
} from "react-icons/fa";

/* ===========================
   DASHBOARD STATISTICS
=========================== */

const stats = [
    {
        title: "Invoices Today",
        value: "56",
        change: "12.5%",
        direction: "up",
        color: "#2563EB",
        bg: "#EFF6FF",
        icon: <FaFileInvoiceDollar />,
    },
    {
        title: "Revenue Today",
        value: "$18,650",
        change: "8.4%",
        direction: "up",
        color: "#16A34A",
        bg: "#ECFDF5",
        icon: <FaMoneyBillWave />,
    },
    {
        title: "Payments Received",
        value: "$14,230",
        change: "6.2%",
        direction: "up",
        color: "#7C3AED",
        bg: "#F5F3FF",
        icon: <FaWallet />,
    },
    {
        title: "Outstanding Amount",
        value: "$42,680",
        change: "3.6%",
        direction: "down",
        color: "#F59E0B",
        bg: "#FFF7ED",
        icon: <FaCoins />,
    },
    {
        title: "Refunds Today",
        value: "$320",
        change: "1.4%",
        direction: "down",
        color: "#EF4444",
        bg: "#FEF2F2",
        icon: <FaUndo />,
    },
];

/* ===========================
   TABS
=========================== */

const tabs = [
    "Invoices",
    "Payments",
    "Refunds",
];

/* ===========================
   ENHANCED BILLING DATA
=========================== */

const billingData = [
    {
        invoiceNo: "MV-2004-0056",
        patient: "John Doe",
        patientId: "OPD-12345",
        department: "Cardiology",
        totalAmount: 450,
        paidAmount: 450,
        dueAmount: 0,
        status: "Paid",
        paymentMethod: "Cash",
        invoiceDate: "21 May 2024",
    },
    {
        invoiceNo: "MV-2004-0056",
        patient: "Mary Jane",
        patientId: "OPD-12346",
        department: "General Medicine",
        totalAmount: 1250,
        paidAmount: 900,
        dueAmount: 350,
        status: "Partial",
        paymentMethod: "Credit Card",
        invoiceDate: "21 May 2024",
    },
    {
        invoiceNo: "MV-2004-0056",
        patient: "Robert Brown",
        patientId: "IPD-54321",
        department: "Cardiology",
        totalAmount: 2850,
        paidAmount: 2850,
        dueAmount: 0,
        status: "Paid",
        paymentMethod: "Insurance",
        invoiceDate: "21 May 2024",
    },
    {
        invoiceNo: "MV-2004-0056",
        patient: "Linda White",
        patientId: "OPD-12347",
        department: "Emergency",
        totalAmount: 2850,
        paidAmount: 2850,
        dueAmount: 0,
        status: "Paid",
        paymentMethod: "Bank Transfer",
        invoiceDate: "21 May 2024",
    },
    {
        invoiceNo: "MV-2004-0056",
        patient: "Marked Lee",
        patientId: "OPD-12348",
        department: "Dermatology",
        totalAmount: 800,
        paidAmount: 800,
        dueAmount: 0,
        status: "Paid",
        paymentMethod: "Cash",
        invoiceDate: "20 May 2024",
    },
    {
        invoiceNo: "MV-2004-0056",
        patient: "Patricia Green",
        patientId: "OPD-12349",
        department: "Pediatrics",
        totalAmount: 800,
        paidAmount: 400,
        dueAmount: 400,
        status: "Partial",
        paymentMethod: "Credit Card",
        invoiceDate: "20 May 2024",
    },
    {
        invoiceNo: "MV-2004-0056",
        patient: "David Wilson",
        patientId: "IPD-54322",
        department: "Neurology",
        totalAmount: 650,
        paidAmount: 0,
        dueAmount: 650,
        status: "Unpaid",
        paymentMethod: "-",
        invoiceDate: "20 May 2024",
    },
    {
        invoiceNo: "MV-2004-0056",
        patient: "Jennifer Taylor",
        patientId: "OPD-12350",
        department: "ENT",
        totalAmount: 1150,
        paidAmount: 1150,
        dueAmount: 0,
        status: "Paid",
        paymentMethod: "Cash",
        invoiceDate: "20 May 2024",
    },
];

/* ===========================
   PAYMENT METHODS DATA
=========================== */

const paymentMethodsData = [
    { method: "Cash", amount: 6180, percentage: 33.2 },
    { method: "Credit Card", amount: 6250, percentage: 33.6 },
    { method: "Online Transfer", amount: 5120, percentage: 27.5 },
    { method: "Insurance", amount: 1100, percentage: 5.7 },
];

/* ===========================
   OUTSTANDING SUMMARY DATA
=========================== */

const outstandingData = [
    { period: "0 - 30 Days", amount: 18450 },
    { period: "31 - 60 Days", amount: 14230 },
    { period: "61 - 90 Days", amount: 7250 },
    { period: "90+ Days", amount: 2750 },
];

/* ===========================
   RECENT PAYMENTS DATA
=========================== */

const recentPayments = [
    { invoice: "MV-2004-0079", amount: 450 },
    { invoice: "MV-2004-0077", amount: 2850 },
    { invoice: "MV-2004-0076", amount: 500 },
    { invoice: "MV-2004-0075", amount: 500 },
];

/* ===========================
   INSURANCE CLAIMS DATA
=========================== */

const insuranceClaims = [
    { status: "Submitted", amount: 450 },
    { status: "Approved", amount: 2850 },
    { status: "Pending", amount: 1150 },
    { status: "Rejected", amount: 1150 },
];

/* ===========================
   COMPONENT
=========================== */

function Billings() {
    const [activeTab, setActiveTab] = useState("Invoices");
    const [search, setSearch] = useState("");
    const [statusFilter, setStatusFilter] = useState("All");
    const [currentPage, setCurrentPage] = useState(1);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedPatient, setSelectedPatient] = useState(null);

    const handleCreateInvoice = () => {
        setSelectedPatient({
            name: "John Doe",
            id: "QPO - 12345",
            age: "34 Y / Male"
        });
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    const handleSaveInvoice = (invoiceData) => {
        console.log("Invoice saved:", invoiceData);
        setIsModalOpen(false);
    };

    const rowsPerPage = 10;

    const filteredBills = useMemo(() => {
        return billingData.filter((bill) => {
            const matchesSearch =
                bill.patient.toLowerCase().includes(search.toLowerCase()) ||
                bill.invoiceNo.toLowerCase().includes(search.toLowerCase()) ||
                bill.department.toLowerCase().includes(search.toLowerCase());

            const matchesStatus =
                statusFilter === "All" ||
                bill.status === statusFilter;

            return matchesSearch && matchesStatus;
        });
    }, [search, statusFilter]);

    const totalPages = Math.ceil(filteredBills.length / rowsPerPage);

    const currentBills = filteredBills.slice(
        (currentPage - 1) * rowsPerPage,
        currentPage * rowsPerPage
    );

    const handlePrevious = () => {
        if (currentPage > 1) {
            setCurrentPage((prev) => prev - 1);
        }
    };

    const handleNext = () => {
        if (currentPage < totalPages) {
            setCurrentPage((prev) => prev + 1);
        }
    };

    const handlePrint = () => {
        window.print();
    };

    const getTotalOutstanding = () => {
        return outstandingData.reduce((sum, item) => sum + item.amount, 0);
    };

    return (
        <div className={classes.page}>
            <Sidebar />
            <div className={classes.main}>
                <Header />
                <div className={classes.content}>
                    {/* PAGE HEADER */}
                    <div className={classes.topSection}>
                        <div>
                            <h2 className={classes.pageTitle}>
                                Billing & Payments
                            </h2>
                            <p className={classes.breadcrumb}>
                                Dashboard
                                <span> &gt; </span>
                                Billing & Payments
                            </p>
                        </div>
                        <div className={classes.topButtons}>
                            <button
                                className={classes.newBtn}
                                onClick={handleCreateInvoice}
                            >
                                <FaPlus />
                                <span>Create Invoice</span>
                            </button>
                            <button
                                className={classes.reportBtn}
                                onClick={handlePrint}
                            >
                                <FaPrint />
                                <span>Reports</span>
                            </button>
                        </div>
                    </div>

                    {/* STATISTICS */}
                    <div className={classes.statsGrid}>
                        {stats.map((item, index) => (
                            <div key={index} className={classes.statCard}>
                                <div
                                    className={classes.iconBox}
                                    style={{
                                        background: item.bg,
                                        color: item.color,
                                    }}
                                >
                                    {item.icon}
                                </div>
                                <div className={classes.statContent}>
                                    <p className={classes.statTitle}>
                                        {item.title}
                                    </p>
                                    <h2 className={classes.statValue}>
                                        {item.value}
                                    </h2>
                                    <div
                                        className={classes.statChange}
                                        style={{
                                            color:
                                                item.direction === "up"
                                                    ? "#16A34A"
                                                    : "#F59E0B",
                                        }}
                                    >
                                        {item.direction === "up"
                                            ? <FaArrowUp />
                                            : <FaArrowDown />
                                        }
                                        <span>
                                            {item.change}
                                            {" "}
                                            from yesterday
                                        </span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* MIDDLE SECTION */}
                    <div className={classes.middleSection}>
                        <div className={classes.leftSection}>
                            <div className={classes.tableHeader}>
                                <div className={classes.tabs}>
                                    {tabs.map((tab) => (
                                        <button
                                            key={tab}
                                            onClick={() => setActiveTab(tab)}
                                            className={
                                                activeTab === tab
                                                    ? classes.activeTab
                                                    : classes.tab
                                            }
                                        >
                                            {tab}
                                        </button>
                                    ))}
                                </div>
                                <div className={classes.tableActions}>
                                    <div className={classes.searchBox}>
                                        <FaSearch />
                                        <input
                                            type="text"
                                            placeholder="Search Invoice, Patient..."
                                            value={search}
                                            onChange={(e) => setSearch(e.target.value)}
                                        />
                                    </div>
                                    <select
                                        className={classes.filterSelect}
                                        value={statusFilter}
                                        onChange={(e) => setStatusFilter(e.target.value)}
                                    >
                                        <option>All</option>
                                        <option>Paid</option>
                                        <option>Partial</option>
                                        <option>Unpaid</option>
                                    </select>
                                    <button className={classes.filterBtn}>
                                        <FaFilter />
                                        <span>Filter</span>
                                    </button>
                                </div>
                            </div>

                            <div className={classes.tableCard}>
                                <table className={classes.table}>
                                    <thead>
                                        <tr>
                                            <th>Invoice No.</th>
                                            <th>Patient Name</th>
                                            <th>Date</th>
                                            <th>Department</th>
                                            <th>Total Amount</th>
                                            <th>Paid Amount</th>
                                            <th>Due Amount</th>
                                            <th>Status</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentBills.map((bill, index) => (
                                            <tr key={index}>
                                                <td>{bill.invoiceNo}</td>
                                                <td>
                                                    <strong>{bill.patient}</strong>
                                                    <br />
                                                    <span className={classes.patientIdText}>
                                                        {bill.patientId}
                                                    </span>
                                                </td>
                                                <td>{bill.invoiceDate}</td>
                                                <td>{bill.department}</td>
                                                <td>${bill.totalAmount.toLocaleString()}</td>
                                                <td>${bill.paidAmount.toLocaleString()}</td>
                                                <td>${bill.dueAmount.toLocaleString()}</td>
                                                <td>
                                                    <span
                                                        className={`${classes.badge}
                                                            ${bill.status === "Paid"
                                                                ? classes.paid
                                                                : bill.status === "Partial"
                                                                    ? classes.partial
                                                                    : classes.unpaid
                                                            }`}
                                                    >
                                                        {bill.status}
                                                    </span>
                                                </td>
                                                <td>
                                                    <div className={classes.actionIcons}>
                                                        <FaEye />
                                                        <FaPrint
                                                            onClick={handlePrint}
                                                        />
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                <div className={classes.pagination}>
                                    <span>
                                        Showing {(currentPage - 1) * rowsPerPage + 1}
                                        {" "}to{" "}
                                        {Math.min(currentPage * rowsPerPage, filteredBills.length)}
                                        {" "}of{" "}
                                        {filteredBills.length} entries
                                    </span>
                                    <div className={classes.pageButtons}>
                                        <button
                                            onClick={handlePrevious}
                                            disabled={currentPage === 1}
                                        >
                                            <FaChevronLeft />
                                        </button>
                                        {Array.from({ length: totalPages }, (_, index) => (
                                            <button
                                                key={index}
                                                onClick={() => setCurrentPage(index + 1)}
                                                className={
                                                    currentPage === index + 1
                                                        ? classes.activePage
                                                        : ""
                                                }
                                            >
                                                {index + 1}
                                            </button>
                                        ))}
                                        <button
                                            onClick={handleNext}
                                            disabled={currentPage === totalPages}
                                        >
                                            <FaChevronRight />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* RIGHT SIDEBAR */}
                        <div className={classes.rightSection}>
                            {/* Payment Methods */}
                            <div className={classes.paymentCard}>
                                <div className={classes.cardHeader}>
                                    <h3>Payment Methods</h3>
                                    <span>Today</span>
                                </div>
                                <div className={classes.paymentChart}>
                                    <div className={classes.paymentCircle}>
                                        <div className={classes.paymentCenter}>
                                            <strong>$18.6K</strong>
                                            <span>Total</span>
                                        </div>
                                    </div>
                                </div>
                                <div className={classes.legend}>
                                    {paymentMethodsData.map((item, index) => (
                                        <div key={index} className={classes.legendItem}>
                                            <span
                                                className={classes.legendColor}
                                                style={{ 
                                                    background: [
                                                        "#2563EB", 
                                                        "#22C55E", 
                                                        "#F59E0B", 
                                                        "#7C3AED"
                                                    ][index] 
                                                }}
                                            />
                                            <span>{item.method}</span>
                                            <strong>{item.percentage}%</strong>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {/* Outstanding Summary */}
                            <div className={classes.summaryCard}>
                                <div className={classes.cardHeader}>
                                    <h3>Outstanding Summary</h3>
                                </div>
                                <div className={classes.summaryRow}>
                                    <span>Total Outstanding</span>
                                    <strong>${getTotalOutstanding().toLocaleString()}</strong>
                                </div>
                                {outstandingData.map((item, index) => (
                                    <div key={index} className={classes.summaryRow}>
                                        <span>{item.period}</span>
                                        <strong>${item.amount.toLocaleString()}</strong>
                                    </div>
                                ))}
                            </div>

                            {/* Recent Payments */}
                            <div className={classes.recentCard}>
                                <div className={classes.cardHeader}>
                                    <h3>Recent Payments</h3>
                                    <span>View All</span>
                                </div>
                                {recentPayments.map((payment, index) => (
                                    <div key={index} className={classes.paymentItem}>
                                        <div>
                                            <strong>{payment.invoice}</strong>
                                            <p>Payment Received</p>
                                        </div>
                                        <strong>${payment.amount.toLocaleString()}</strong>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* BOTTOM SECTION */}
                    <div className={classes.bottomSection}>
                        {/* Department Revenue */}
                        <div className={classes.bottomCard}>
                            <div className={classes.cardHeader}>
                                <h3>Department Revenue</h3>
                                <button className={classes.viewAllBtn}>
                                    View Report
                                </button>
                            </div>
                            <div className={classes.departmentRow}>
                                <span>Cardiology</span>
                                <strong>$18,250</strong>
                            </div>
                            <div className={classes.departmentRow}>
                                <span>Laboratory</span>
                                <strong>$14,800</strong>
                            </div>
                            <div className={classes.departmentRow}>
                                <span>Radiology</span>
                                <strong>$12,500</strong>
                            </div>
                            <div className={classes.departmentRow}>
                                <span>Pharmacy</span>
                                <strong>$10,320</strong>
                            </div>
                            <div className={classes.departmentRow}>
                                <span>Emergency</span>
                                <strong>$8,750</strong>
                            </div>
                        </div>

                        {/* Outstanding Patients */}
                        <div className={classes.bottomCard}>
                            <div className={classes.cardHeader}>
                                <h3>Top Outstanding Patients</h3>
                                <button className={classes.viewAllBtn}>
                                    View All
                                </button>
                            </div>
                            <div className={classes.resultList}>
                                <div className={classes.resultItem}>
                                    <div>
                                        <strong>David Wilson</strong>
                                        <p>INV240521-005</p>
                                    </div>
                                    <span className={classes.unpaidBadge}>
                                        $5,200
                                    </span>
                                </div>
                                <div className={classes.resultItem}>
                                    <div>
                                        <strong>Robert Brown</strong>
                                        <p>INV240521-003</p>
                                    </div>
                                    <span className={classes.unpaidBadge}>
                                        $4,500
                                    </span>
                                </div>
                                <div className={classes.resultItem}>
                                    <div>
                                        <strong>Mary Jane</strong>
                                        <p>INV240521-002</p>
                                    </div>
                                    <span className={classes.partialBadge}>
                                        $800
                                    </span>
                                </div>
                            </div>
                        </div>

                        {/* Insurance Claims */}
                        <div className={classes.bottomCard}>
                            <div className={classes.cardHeader}>
                                <h3>Insurance Claims</h3>
                                <button className={classes.viewAllBtn}>
                                    View All
                                </button>
                            </div>
                            <div className={classes.claimsGrid}>
                                {insuranceClaims.map((claim, index) => (
                                    <div key={index} className={classes.claimItem}>
                                        <div className={classes.claimInfo}>
                                            <span className={classes.claimIcon}>
                                                {claim.status === "Approved" && <FaCheckCircle />}
                                                {claim.status === "Rejected" && <FaTimesCircle />}
                                                {claim.status === "Pending" && <FaHourglassHalf />}
                                                {claim.status === "Submitted" && <FaClock />}
                                            </span>
                                            <span>{claim.status}</span>
                                        </div>
                                        <strong>${claim.amount.toLocaleString()}</strong>
                                    </div>
                                ))}
                                <div className={classes.claimTotal}>
                                    <span>Total Claimed</span>
                                    <strong>
                                        ${insuranceClaims.reduce((sum, item) => sum + item.amount, 0).toLocaleString()}
                                    </strong>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <CreateInvoiceModal
                isOpen={isModalOpen}
                onClose={handleCloseModal}
                onSave={handleSaveInvoice}
                patientData={selectedPatient}
            />
        </div>
    );
}

export default Billings;